module.exports = __webpack_public_path__ + "img/weekly.812c6832.png";